import Register from "../Auth/Register"
import VerifyOtp from "../Auth/Verify-OTP"
import BoardingSeatSelection from "../BusSearchLayout/Boarding-Dropping-point"
import BusFound from "../BusSearchLayout/Busfound"
import CompleteYourPayment from "../BusSearchLayout/Complete-your-payment"
import Home from "../HomeLayout/Home"
import MyAccount from "../MyAccount/My-Account"
import SupportCenter from "../SupportCenter/Support-Center"
import Viewallfaq from "../SupportCenter/View-All-Faq"



const AuthRoute = [
    { path: '/auth', element: <Register /> },
    { path: '/verify-otp/:mobile?/:otp?', element: <VerifyOtp /> }
]


const PageRoute = [
    { path: '/', element: <Home /> },
    { path: '/bus-tickets/:fromId/:toId/:travelDate', element: <BusFound /> },
    { path: '/busfound', element: <BusFound /> },
    { path: '/boardingseat/:trackId/:details/:bookedSeat/:boardingPoint/:droppingPoint/:travelDate', element: <BoardingSeatSelection /> },
    { path: '/complete-your-payment', element: <CompleteYourPayment /> },
    { path: '/my-account', element: <MyAccount /> },
    { path: '/supportcenter', element: <SupportCenter /> },
    { path: '/viewallfaq', element: <Viewallfaq /> },
]

export { AuthRoute, PageRoute }